import { nth, throttle } from 'lodash'
import withProps from 'recompose/withProps'
import { getScrollTop } from '../../util/scrolling'
import { giphyAqua, giphyIndigo, giphyCornflower, giphyPink } from '../../css/colors.css'

// just to be safe, throttle this
const throttledScrollTop = throttle(() => getScrollTop() / window.innerHeight, 100)

export const getGradient = (gradientIndex, gradientColors) => {
    const index = Math.floor(throttledScrollTop())
    return nth(gradientColors, index % gradientColors.length)
}

// Use in conjunction with scroll props proxy to make sure this refreshes on scroll
export default (gradientIndex = 18, gradientColors = [giphyAqua, giphyIndigo, giphyCornflower, giphyPink]) => {
    // only update prop when appWidth changes
    return withProps(() => ({
        backgroundColor: getGradient(gradientIndex, gradientColors),
    }))
}
